<template>
    <div class="user container">
        <div class="user-container text-center" v-if="user.loading">
            <font-awesome-icon class="spinner" size="2x" icon="circle-notch" :spin="true"/>
        </div>
        <div class="user-container" v-else-if="user.statusOk && user.data">
            <b-card class="text-center">
                <b-media>
                    <b-img v-if="user.data.imageURI" :src="user.data.imageURI" width="100" height="100" alt="user image" />
                    <font-awesome-icon v-else size="3x" icon="image"/>
                    <h3 class="mt-0">{{user.data.name}} <small class="store-tag" v-if="user.data.role === 'store'">{{langUserPage.store[locale]}}</small></h3>
                    <div class="card-text address">
                        <strong>{{user.data.address}}</strong><small v-if="!!user.data.address"> > </small><strong>{{user.data.city}}</strong><small> > </small><strong>{{user.data.province}}</strong><small> > </small><strong>{{user.data.country}}</strong>
                    </div>
                    <div class="card-text contact">
                        <a :href="`mailto:${user.data.email}?Subject=nettipyora.fi`" target="_top">
                            {{user.data.email}}
                        </a>
                        <div class="text-center" style="width: 1rem; display: inline-block"> | </div> <a :href="'tel:'+user.data.phone">{{user.data.phone}}</a>
                    </div>
                </b-media>
            </b-card>
            <br />
            <b-card :title="langUserPage.moreContacts[locale]" v-if="user.data.contacts.length > 0">
                <div class="card-text" v-for="(contact, i) in user.data.contacts" :key="i">
                    <strong>{{contact.name}}</strong> 
                    <div class="text-center" style="width: 1rem; display: inline-block"> | </div> 
                    <span class="language-tag" v-for="(l, n) in contact.languages" :key="n">{{l}}</span> 
                    <div class="text-center" style="width: 1rem; display: inline-block"> | </div>
                    <strong><a :href="`mailto:${contact.email}?Subject=nettipyora.fi`" target="_top">{{contact.email}}</a></strong> <div class="text-center" style="width: 1rem; display: inline-block"> | </div> 
                    <strong><a :href="'tel:'+contact.phone">{{contact.phone}}</a></strong>
                </div>
            </b-card>
            <br />
            <b-card :title="langUserPage.reviews[locale]">
                <b-form @submit.stop.prevent="submitReview" v-if="$route.params.userID !== authenticatedUserID && $store.getters.isAuthenticated">
                    <b-form-group :label="langUserPage.rating[locale]">
                        <vue-slider style="width: 50%; min-width: 300px; margin: auto" v-model="newReview.score" :speed="0.3" :min="1" :max="10" :piecewise="true"></vue-slider>
                    </b-form-group>
                    <!--<b-form-group :label="langUserPage.reviewText[locale]" label-for="textarea1">-->
                    <b-form-group label-for="textarea1">
                        <b-form-textarea id="textarea1" v-model="newReview.text" :placeholder="langUserPage.reviewTextPlaceholder[locale]" :rows="3" :max-rows="6"></b-form-textarea>
                    </b-form-group>
                    <b-alert :show="!!review.message" :variant="review.statusOk ? 'success' : 'danger'">{{review.message}}</b-alert>
                    <nettipyora-button :text="langUserPage.submit[locale]" :loading="review.creating" :type="'submit'" :className="'btn-info'"  />
                </b-form>
                <router-link class="btn btn-primary" v-if="!$store.getters.isAuthenticated" :to="'/login'">{{langUserPage.loginToSubmitReview[locale]}}</router-link>
                <br /><br />
                <div class="review-container" v-if="user.data.reviews.length > 0">
                    <review v-for="(review, i) in reversedReviews" :key="i" v-show="i<1 || showAllReviews" :review="review" @removeClicked="removeReview(review._id)"/>
                    <div class="review-show-all text-center" v-if="user.data.reviews.length>1">
                        <b-button style="color: gray; text-decoration: none" variant="link" v-on:click.stop="showAllReviews = !showAllReviews">
                            <small style="margin-right: 1em;">{{showAllReviews ? 'Hide' : 'Show all'}}</small>
                            <font-awesome-icon class="show-all-icon" :icon="showAllReviews ? 'angle-double-up' : 'angle-double-down'"/>
                        </b-button>
                    </div>
                </div>
                <div class="review-none text-center" v-else>
                    <span class="text-muted">{{langUserPage.noReview[locale]}}</span>
                </div>
            </b-card>
        </div>
        <div class="user-container" v-else>
            <b-alert show variant="danger">{{langUserPage.serverError[locale]}}</b-alert>
        </div>
        <br />
        <b-card :title="langUserPage.searchPosts[locale]">
            <div class="card-text">
                <quick-search :value="query" :search="searchPost" :loading="post.searchingCount" :showStatus="true" :count="post.searchCount" :queryChanged="searchPostQueryChanged"/>
            </div>
            <div class="container" v-if="post.loadingPosts">
                <font-awesome-icon class="spinner" size="2x" icon="circle-notch" :spin="true"/>
            </div>
            <div class="card-text" v-else-if="post.items.length > 0">
                <post v-for="item in post.items" :post="item" :key="item._id" style="margin: 5px"/>
                <br />
                <br />
                <b-pagination align="center" size="md" :total-rows="post.total" v-model="currentPage" :per-page="post.itemsPerPage" @change="pageClicked">
                </b-pagination>
            </div>
            <div class="card-text" v-else>
                <br />
                <b-alert show variant="danger" v-if="post.statusOk === false && post.errMessage">{{post.errMessage}}</b-alert>
                <strong class="no-result" v-else-if="post.statusOk">{{langUserPage.noPostFound[locale]}}</strong>
            </div>
        </b-card>
    </div>
</template>

<script>
import QuickSearch from '@/components/QuickSearch';
import vueSlider from 'vue-slider-component';
import NettipyoraButton from '@/components/NettipyoraButton';
import Review from '@/components/Review';
import { mapState } from 'vuex';
import langUserPage from '@/store/lang/userPage';
import Post from '@/components/Post.vue';

export default {
    name: "user",
    components: {
        NettipyoraButton,
        vueSlider,
        Review,
        QuickSearch,
        Post
    },
    computed: {
        ...mapState({
            locale: state => state.locale,
            user: state => state.User.user,
            review: state => state.User.review,
            post: state => state.User.post,
            authenticatedUserID: state => state.authenticatedUserID
        }),
        reversedReviews () {
            return this.user.data.reviews ? this.user.data.reviews.reverse() : [];
        }
    },
    mounted() {
        this.$store.dispatch('USER_FETCH', this.$route.params.userID);
        this.$store.dispatch('USER_POST_FETCH_COUNT', {userID: this.$route.params.userID})
    },
    data() {
        return {
            query: {
                types: null,
                subTypes: null,
                status: null,
                provinces: null,
                cities: null,
                minPrice: undefined,
                maxPrice: undefined,
                condition: null
            },
            langUserPage,
            newReview: {
                text: "", 
                score: 1
            },
            showAllReviews: false,
            currentPage: 1
        }
    },
    methods: {
        submitReview() {
            this.$store.dispatch('USER_POST_REVIEW', {userID: this.$route.params.userID, payload: this.newReview}).then(() => {
                this.newReview = {
                    text: "", 
                    score: 1
                };
            });
        },
        removeReview(reviewID) {
            //console.log('review', reviewID);
            this.$store.dispatch('UESER_REVIEW_DELETE', {reviewID, userID: this.$route.params.userID});
        },
        searchPost(query) {
            //goto userPosts
            this.query = query;
            query.page = this.currentPage;
            query.userID = this.$route.params.userID;
            this.$store.dispatch('USER_POST_FETCH', query);
        },
        searchPostQueryChanged(query) {
            query.userID = this.$route.params.userID;
            this.$store.dispatch('USER_POST_FETCH_COUNT', query);
        },
        pageClicked(newPageNum) {
            const query = JSON.parse(JSON.stringify(this.query));
            query.page = this.currentPage = newPageNum;
            query.userID = this.$route.params.userID;
            this.$store.dispatch('USER_POST_FETCH', query);
        }
    }
}
</script>

<style scope lang="scss">
.user {
    .spinner {
        margin: 2em;
    }
    .user-container {
        margin-top: 1em;

        .address {
            font-size: 0.8em;
        }
        .contact {
            font-size: 0.9em;
        }
        .language-tag {
            padding-left: 5px;
            padding-right: 5px;
            background: gray;
            border-radius: 2px;
            color: white;
            margin: 2px;
        }
        .store-tag {
            padding-left: 5px;
            padding-right: 5px;
            margin-left: 5px;
            margin-right: 5px;
            background: gray;
            border-radius: 2px;
            color: white;
        }
        .review-none {
            border: 1px solid darkgray;
            padding: 0.5em;
            border-radius: 5px;
        }
    }
}
</style>
